<template>
  <div
    :id="id"
    class="element slideshow-widget draggable"
    :class="[element.cssClasses, { locked: element.locked }]"
  >
    <progress-indicator
      v-if="element.hasProgressIndicator"
      :toggle="toggle && isSelected && !element.locked"
      :element="virtualProgressIndicator"
    />
    <element-renderer
      v-for="(elementId) in childElementsReversed"
      v-show="!getElementById(elementId)?.layerHiddenInGraphics"
      :id="elementId"
      :key="elementId"
      :type="getElementById(elementId).type"
      :toggle="toggle"
      @select="select"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapActions } from 'vuex';
import ElementsMixins from '../../../../mixins/elements-mixins';
import ProgressIndicator from './ProgressIndicator.vue';

export default {
  name: 'SlideshowElement',
  components: {
    ProgressIndicator,
    ElementRenderer: defineAsyncComponent(() => import('../../ElementRenderer')),
  },
  mixins: [ElementsMixins],
  data() {
    return {
      piId: `virtual-progress-indicator-${this.id}`,
    };
  },
  watch: {
    // shim for weird internal element that isn't built like other elements
    // but needs to function like them. We created a virtual element that isn't
    // in the elementsGroupMap and sync it here to the data prop for it.
    virtualProgressIndicator: {
      handler(v) {
        this.setOneElementValueByProp({
          value: {
            id: this.id,
            propKey: 'progressIndicator',
            propValue: v,
          },
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('graphicsTemplate', [
      'addNewElement',
    ]),
    select(event, id) {
      if (event.shiftKey) {
        this.$store.dispatch('updateSelectedElements', id);
      } else {
        this.$store.dispatch('selectElements', [id]);
      }
    },
  },
  computed: {
    childElementsReversed() {
      return [...this.getElementGroupMap[this.id]].reverse();
    },
    virtualProgressIndicator() {
      return this.getElementById(this.piId);
    },
  },
  created() {
    // create virtual element for progressIndicator
    this.addNewElement({
      value: {
        type: 'progress-indicator',
        settings: {
          id: this.piId,
          ...this.element.progressIndicator,
        },
      },
      options: {
        blacklist: true,
        skipMapping: true,
      },
    });
  },
};
</script>
